import { IMarketingCloudUser, SportradarEnforcer, SportradarEnforcerFactory } from '@ads/iam-library';

let cachedEnforcer: SportradarEnforcer;

// eslint-disable-next-line import/prefer-default-export
export async function getCachedEnforcer(user: IMarketingCloudUser): Promise<SportradarEnforcer> {
    if (cachedEnforcer) {
        return cachedEnforcer;
    }
    cachedEnforcer = await new SportradarEnforcerFactory().createFromMarketingCloudUser(user);
    return cachedEnforcer;
}
